module.exports = __webpack_public_path__ + "static/media/ROGER-CHURCH.69a028c3.png";